import makeStyles from '@mui/styles/makeStyles';

export default makeStyles({
  boldText: {
    fontFamily: 'lato-bold',
  },
});
